'use client';

import { useTheme } from "next-themes";
import { useEffect, useState } from "react";
import { MdDarkMode } from "react-icons/md";

interface ThemeSelectorProps {
    className?: string;
    iconClassName?: string;
    ariaLabel?: string;
}

const DEFAULT_CLASS = "icon-btn flex text-foreground hover:text-primary transition-colors";
const DEFAULT_ICON_CLASS = "icon";

const ThemeSelector = ({ className, iconClassName, ariaLabel = 'Toggle dark mode' }: ThemeSelectorProps = {}) => {
    const { setTheme, resolvedTheme } = useTheme();
    const [mounted, setMounted] = useState(false);

    useEffect(() => setMounted(true), []);

    const handleClick = () => {
        if (!mounted) return;
        setTheme(resolvedTheme === 'dark' ? 'light' : 'dark');
    };

    return (
        <button
            type="button"
            className={className ?? DEFAULT_CLASS}
            onClick={handleClick}
            aria-label={ariaLabel}
            suppressHydrationWarning
        >
            <MdDarkMode className={iconClassName ?? DEFAULT_ICON_CLASS} />
        </button>
    )
}

export default ThemeSelector;